import React, {
  ReactNode,
  DetailedHTMLProps,
  ButtonHTMLAttributes,
  CSSProperties,
} from 'react';

type Props = {
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  type?: 'submit' | 'reset' | 'button';
  onClick?: (event?: MouseEvent) => void;
  style?: CSSProperties;
  children: ReactNode;
};

const Button: React.FC<
  Props &
    DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
> = props => {
  const { className, type = 'button', children, isLoading = false, ...rest } = props;
  return (
    <button type={type} className={`btn ${className || 'btn-orange'}`} {...rest}>
      {isLoading && (
        <>
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>{' '}
        </>
      )}
      {children}
    </button>
  );
};

export default Button;
